export default {
  name: 'x-plus-modal-tab-complementares',
  props: {
    exam: { type: Object, default: null },
    camposComplementares: { type: Array, default: () => [] },
    formComplementares: { type: Object, required: true },
    cpfValido: { type: Boolean, default: true },
    dataNascimentoValida: { type: Boolean, default: true },
    selectedFichaId: { type: [String, Number], default: null },
    isExamEditable: { type: Boolean, default: false },
    isGestorSaudeDisabled: { type: Boolean, default: false },
    onCampoInput: { type: Function, required: true },
    widthByMaxLength: { type: Function, required: true },
    abrirHelperCampo: { type: Function, required: true },
    isFieldEditable: { type: Function, required: true },
    removerFichaConfirmacao: { type: Function, required: true }
  }
}
